/* eslint-disable */
import { csContext } from "../../services/cs-context";
import cms from "../../services/cms/cms";
import axios from "axios";
import { CmsDocument, CmsDocumentTypes } from "services/cms/cms-type-definitions";
import { complete, splitRegex } from "./complete";
import getEmbedding from "./get-embedding";
import { CmsDocumentSituationApiModel } from "api-models";

let typeDescriptors = {
  "cms-develop-page": "Development Document",
  "cms-resource": "General Document",
  "cms-pathway": "Team Pathway",
  "cms-personal-pathway": "Personal Pathway",
  "cms-personal-pathway-step": "Personal Pathway Step",
  "cms-pathway-step": "Team Pathway Step",
  "cms-develop-plan": "Personal Development Plan",
};
let getDocTitle = (doc: CmsDocument) => cms.asText(doc.data["title"]);

let l = (title: string) => `Can this document help me? 7 questions to ask yourself.
1. Do i have enough time to read "${title}"? YES/NO/MAYBE
2.`;

async function processDocument(doc: CmsDocument) {
  let allText = getText(doc).join("\n").replace(/ +/g, " ");
  //limit length
  let docText = allText.substring(0, allText.split(" ", 2500).join(" ").length);
  let docTextForEmbedding = allText.substring(0, allText.split(" ", 5900).join(" ").length);

  let title = getDocTitle(doc);

  let smartSummaryPromise = complete(
    docText + "\n\n-----\n\n" + `Write a summary of this article.\n\n|>|This article`,
    {
      user: "system",
      max_tokens: 300,
    },
  );

  let smartOneSentenceSummaryPromise = complete(
    `${await smartSummaryPromise}\n\n\n\nSummarize in one sentence.\n\n|>|This article`,
    {
      user: "system",
      max_tokens: 300,
    },
  );

  let data: CmsDocumentSituationApiModel = {
    id: doc.id,
    uid: doc.uid!,
    title: title,

    type: doc.type,
    tags: doc.tags,

    relevanceSummary: await smartSummaryPromise,
    displaySummary: await smartOneSentenceSummaryPromise,
    lastPublicationDate: doc.last_publication_date,
    firstPublicationDate: doc.first_publication_date,
    text: allText,
    embedding: await getEmbedding(docTextForEmbedding),
  };

  await axios.put("/api/cmsdocumentsituations", data);
  return data;
}

export function getText(obj: CmsDocument): string[] {
  let result: string[] = [];

  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const element = obj[key];
      if (typeof element === "object") {
        result = result.concat(getText(element));
      } else if (key === "text") {
        result.push(element);
      }
    }
  }

  return result;
}

let hasClearedWindow = false;
let logToWindow = function (a: string) {
  if (!hasClearedWindow) {
    window.document.body.innerHTML = "";
    hasClearedWindow = true;
  }

  window.document.body.innerHTML += "<p>" + a + "</p>";
  // console.log(a);
};

async function processSituations() {
  let log = logToWindow;

  try {
    log(" -- STARTING PROCESSING FOR JYRE RECOMMENDS --");
    //let personalPathways: CmsDocument[] = await cms.getAll("cms-personal-pathway" as any);
    //let developPlans = await cms.getAll("cms-develop-plan");
    log("Downloading Personal Pathways from CMS");
    let personalPathways = (await cms.getAll("cms-personal-pathway")) as CmsDocument[];
    // let developDays = (await cms.getAll("cms-develop-page")) as CmsDocument[];
    log("Downloading Team Pathways from CMS");
    let teamPathways = (await cms.getAll("cms-pathway")) as CmsDocument[];
    log("Downloading Resources from CMS");
    let resources = (await cms.getAll("cms-resource")) as CmsDocument[];
    // let personalPathwaySteps = (await cms.getAll("cms-personal-pathway-step")) as CmsDocument[];
    // let teamPathwaySteps = (await cms.getAll("cms-pathway-step")) as CmsDocument[];
    log("Downloading Sessions from CMS");
    let sessions = (await cms.getAll("cms-session-with-slides")) as CmsDocument[];

    let documents = [
      personalPathways,
      teamPathways,
      resources,
      sessions,
      //personalPathwaySteps,
      //teamPathwaySteps,
      //developDays,
    ].reduce((accumulator, value) => accumulator.concat(value), []);
    log("Downloading previous runs for reference");
    let situations = (await axios.get("/api/cmsdocumentsituations"))
      .data as CmsDocumentSituationApiModel[];
    // Do what hasn't been done before first.
    let a = documents.filter((doc) => !situations.some((s) => s.id === doc.id));
    let b = documents.filter((doc) => situations.some((s) => s.id === doc.id));
    let deleted = situations.filter((s) => !documents.some((d) => d.id === s.id));
    documents = a.concat(b);
    log("-- Starting situation & summarization--");
    for (let i = 0; i < documents.length; i++) {
      if (i == a.length) {
        log(
          "-- Unprocessed documents done. Starting on documents that have been processed before. --",
        );
      }
      let doc = documents[i];
      let sit = await processDocument(doc);
      log(sit.uid + ": " + sit.relevanceSummary);
    }

    if (deleted.length) {
      console.info("-- All documents done; deleting leftover documents --");
      for (let i = 0; i < deleted.length; i++) {
        let doc = deleted[i];
        log("DELETING: " + doc.uid);
        await axios.delete("/api/cmsdocumentsituations/" + doc.id);
      }
    } else {
      console.info("-- Nothing to Delete --");
    }

    log("-- DONE --");
  } catch (ex) {
    log("## ERROR ##");
    console.error(ex);
  }
}

export { processSituations, getEmbedding };
